import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeSection = ({ user }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className="bg-gradient-to-r from-primary to-blue-700 text-primary-foreground rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold mb-2">
            {getGreeting()}, {user.firstName}!
          </h1>
          <p className="text-blue-100 mb-4">
            Welcome back to your account dashboard
          </p>
          <div className="flex items-center space-x-4 text-sm">
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} />
              <span>Account Verified</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Star" size={16} />
              <span>{user.membershipLevel} Member</span>
            </div>
          </div>
        </div>
        <div className="hidden md:block">
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center">
            <Icon name="User" size={32} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;